import { useLanguage } from '../../commonHooks/useLocalization';
import { HospitalConstants } from '../../utils/constants/HospitalConstants';
import { feedlotManagerFeatures } from '../../apps/feedlotManager/featureFlags/feedlotManagerFeatures';
const HospitalAccordionHeader = () => {
    const language = useLanguage();
    const { isADO240979On_HospitalAddCleanDateColumn } = feedlotManagerFeatures;
    return (
        <div className="col">
            <div className="row">
                <div className="col-2 px-2">
                    {
                        HospitalConstants[language.value].accordionHeader
                            .hospitalPen.label
                    }
                </div>
                <div
                    className={
                        isADO240979On_HospitalAddCleanDateColumn
                            ? 'col-1 px-2'
                            : 'col-2 px-2'
                    }
                >
                    {
                        HospitalConstants[language.value].accordionHeader.lot
                            .label
                    }
                </div>
                <div
                    className={
                        isADO240979On_HospitalAddCleanDateColumn
                            ? 'col-1 px-2'
                            : 'col-2 px-2'
                    }
                >
                    {
                        HospitalConstants[language.value].accordionHeader
                            .animalId.label
                    }
                </div>
                <div className="col-2 px-2">
                    {
                        HospitalConstants[language.value].accordionHeader.eid
                            .label
                    }
                </div>
                <div className="col-2 px-2">
                    {
                        HospitalConstants[language.value].accordionHeader
                            .homePen.label
                    }
                </div>
                {isADO240979On_HospitalAddCleanDateColumn && (
                    <div className="col-2 px-2">
                        {
                            HospitalConstants[language.value].accordionHeader
                                .cleanDate.label
                        }
                    </div>
                )}
            </div>
        </div>
    );
};

export default HospitalAccordionHeader;
